import { AxiosError } from "axios";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import axiosInstance from "src/config/axios";
import { KybPaginatedResponse } from "./kyb.type";

export const useKybVerificationQuery = () => {
  const { data, error, isLoading, mutate } = useSWR<
    KybPaginatedResponse,
    AxiosError,
    `/comp/kybVerification`
  >(
    `/comp/kybVerification`,
    (url: string) => axiosInstance.get(url).then((res) => res.data.data),
    {
      refreshWhenHidden: true,
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnMount: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    kybRecords: data,
    isLoading,
    error,
    getKybRecords: mutate,
  };
};

export const useSubmitKybMutation = () => {
  const { data, trigger, isMutating, error } = useSWRMutation<
    {},
    AxiosError,
    `/comp/kybVerification`,
    FormData,
    any
  >(`/comp/kybVerification`, (url: string, { arg }) =>
    axiosInstance.post(url, arg).then((res) => res.data)
  );

  return {
    data,
    isLoading: isMutating,
    submitKyb: trigger,
  };
};
